import { useSuspenseQuery } from '@tanstack/react-query';

import { getRequest } from '@/api/rest/hooks/requests/get';
import { usePostLimitedAccessOrganization } from '@/api/rest/resources/limitedAccessOrganization';
import {
  GET_ORGANIZATION_LIMITED_ACCESS_ORGANIZATION_PATH,
  GetOrganizationLimitedAccessOrganizationErrorDto,
  GetOrganizationLimitedAccessOrganizationSuccessDto,
} from '@/api/rest/resources/types/limitedAccessOrganization';

type SuccessDto = GetOrganizationLimitedAccessOrganizationSuccessDto;
type ErrorDto = GetOrganizationLimitedAccessOrganizationErrorDto;

export const useLimitedAccessOrganization = (organizationIdArg: string, filters?: Record<string, string>) => {
  const pathVariables = {
    organization_id: organizationIdArg,
  };
  const queryParams = {
    ...(filters ?? {}),
  };

  const queryFn = () => {
    return getRequest<SuccessDto>(GET_ORGANIZATION_LIMITED_ACCESS_ORGANIZATION_PATH, pathVariables, queryParams);
  };

  return useSuspenseQuery<SuccessDto, ErrorDto>({
    queryKey: ['organization', pathVariables, 'limited-access-organization', queryParams],
    queryFn,
    staleTime: 1000 * 60 * 5,
  });
};

export const useCreateLimitedAccessOrganization = () => {
  const mutation = usePostLimitedAccessOrganization();

  const submit = async (organizationId: string, plotGroupsIds: string[], userIds: string[], onSuccess?: () => void) => {
    const postBody = {
      plot_group_ids: plotGroupsIds,
      user_ids: userIds,
    };

    const response = await mutation.mutateAsync({
      pathVariables: { organization_id: organizationId },
      bodyData: postBody,
    });

    onSuccess?.();

    return response;
  };

  const isSubmitting = mutation.isPending;

  return { submit, isSubmitting };
};
